var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53456 0.548286C1.9181 0.068961 1.02674 0.112536 0.460261 0.679011C-0.15342 1.29269 -0.15342 2.28767 0.460261 2.90135L8.77767 11.2188L0.460261 19.5362L0.329536 19.6842C-0.149789 20.3006 -0.106214 21.192 0.460261 21.7585C1.07394 22.3722 2.06892 22.3722 2.6826 21.7585L11 13.4411L19.3174 21.7585L19.4654 21.8892C20.0819 22.3685 20.9733 22.325 21.5397 21.7585C22.1534 21.1448 22.1534 20.1498 21.5397 19.5362L13.2223 11.2188L21.5397 2.90135L21.6705 2.75331C22.1498 2.13685 22.1062 1.24549 21.5397 0.679011C20.9261 0.0653298 19.9311 0.0653298 19.3174 0.679011L11 8.99642L2.6826 0.679011L2.53456 0.548286Z",
    fill: "#51597B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.07888d5bbeeadea67f850efac1b7db92.svg";
export { ForwardRef as ReactComponent };